module.exports = __webpack_public_path__ + "img/0706-化妆品种类-下-02.d9fe94c6.png";